import React from "react";
import Nav from "../../Nav";
import { Container, Typography, Box, Card, CardContent, CardMedia, Button, List, ListItem, ListItemText, Grid } from '@mui/material';
import blog1 from "../images/card5.webp";
import pr1 from "../images/pro1.webp";
import pr2 from "../images/pro2.webp";
import { motion } from 'framer-motion';




const GrammarCard1 = ({ post }) => {

    return (
        <>
            <Nav />
            <Box sx={{ backgroundColor: '#f8fafc', py: 8, fontFamily: 'Arial, sans-serif' }}>
                <Box sx={{ py: 15, textAlign: 'center', color: '#000000' }} style={{ backgroundColor: '#f8fafc' }}>
                    <Container maxWidth="lg" style={{ backgroundColor: '#f8fafc' }}>
                        <Typography variant="h3" align="center" className='merriweather-bold' gutterBottom sx={{ fontWeight: 'bold' }}>
                            Possessive Pronouns
                        </Typography>
                        <div id="image-container" className="absolute top-20 left-0">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png' className="ml-4 mt-4" alt="Small Image" />
                        </div>
                        <div id="image-container2" className="absolute top-20 right-80">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/07/shape-37.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute top-120 right-40">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-02.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute bottom-20 right-0">
                            <img src='https://demo.edublink.co/wp-content/themes/edublink/assets/images/shapes/breadcrumb-shape-3.png' className="h-48 w-32" alt='' />
                        </div>
                    </Container>
                </Box>

                <Container maxWidth="lg" sx={{ backgroundColor: '#ffffff', p: 5, borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', mt: -8 }}>
                    <Grid container spacing={5} alignItems="flex-start" mb={4}>
                        <Grid item xs={12} lg={6}>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Students often confuse the<i><b>Possessive Pronouns</b></i>  in English with<i><b> Possessive Nouns</b></i>  or<i><b> Possessive Adjectives.</b></i>  Let’s dive in and hopefully clear out some of the confusion.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                First of all, let us explain the basics and clearly define the <u><b>grammar roles in singular and plural </b></u>along with some practical examples:
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                <i><b><u>The Singular Forms:</u></b></i>
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c' }}>
                                1. Mine: Used to indicate <i><b>possession by the speaker.</b></i>
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c', marginLeft: '15px', marginTop: '-10px' }}>
                                Example: "This book is mine."
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c' }}>
                                2. Your: Used to indicate possession by <i><b>the person being spoken to (singular).</b></i>
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c', marginLeft: '15px', marginTop: '-10px' }}>
                                Example: "Is this your car?"
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c' }}>
                                3. His: Used to indicate possession by <i><b>a male person or thing.</b></i>
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c', marginLeft: '15px', marginTop: '-10px' }}>
                                Example: "That dog is his."
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c' }}>
                                4. Hers: Used to indicate possession by<i><b> a female person or thing.</b></i>
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c', marginLeft: '15px', marginTop: '-10px' }}>
                                Example: "The house is hers."
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c' }}>
                                5. Its: Used to indicate possession by<i><b> a non-human entity,</b></i> such as an animal or an object.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c', marginLeft: '15px', marginTop: '-10px' }}>
                                Example: "The cat licked its paw."
                            </Typography>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
                                <CardMedia
                                    component="img"
                                    image={blog1}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', height: '600px' }}
                                />
                            </motion.div>
                        </Grid>
                    </Grid>

                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <i><u><b>The Plural Forms:</b></u></i>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c' }}>
                        6. Ours: Used to indicate possession by <i><b>the speaker and one or more other people.</b></i>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c', marginLeft: '15px', marginTop: '-10px' }}>
                        Example: "The house is ours."
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c' }}>
                        7. Yours: Used to indicate possession by the <i><b>person or people being spoken to (plural).</b></i>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c', marginLeft: '15px', marginTop: '-10px' }}>
                        Example: "Are these books yours?"
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c' }}>
                        8. Theirs: Used to indicate possession by<i><b> other people or things previously mentioned or easily identified.</b></i>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', color: '#6b778c', marginLeft: '15px', marginTop: '-10px' }}>
                        Example: "The keys are theirs."
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <i><u><b>Possessive pronouns are often used to avoid repetition or to emphasize ownership.</b></u></i> They agree in number and gender with the noun they replace, and <i><u><b>they do not require an apostrophe ('s) </b></u></i>like possessive nouns do.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        They are essential for clear communication and help avoid confusion about who or what possesses something.
                    </Typography>

                    <Grid item xs={12} lg={11} container spacing={2}>
                        <Grid item xs={6} paddingBottom={'20px'}>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                <CardMedia
                                    component="img"
                                    image={pr1}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2 }}
                                />
                            </motion.div>
                        </Grid>
                        <Grid item xs={6}>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                <CardMedia
                                    component="img"
                                    image={pr2}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2 }}
                                />
                            </motion.div>
                        </Grid>
                    </Grid>
                </Container >
            </Box >
        </>
    );
};

export default GrammarCard1;
